module.exports = __webpack_public_path__ + "static/img/son6_active.4e21fe57.png";